import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadMyOrdersSuccessAction, myOrdersActionTypes} from '../actions/my-orders';
import {Order} from '../../order/models/order';


export interface MyOrdersState {
  array: Order[];
}

const initialState: MyOrdersState = {
  array: []
};

export function myOrdersReducer(state: MyOrdersState = initialState, action: Action): MyOrdersState {
  switch (action.type) {
    case myOrdersActionTypes.LOAD:
      return handleLoadAction();
    case myOrdersActionTypes.LOAD_SUCCESS:
      return handleLoadSuccess(state, action);
    case myOrdersActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadAction(): MyOrdersState {
  return initialState;
}

function handleLoadSuccess(state: MyOrdersState, action: LoadMyOrdersSuccessAction): MyOrdersState {
  const newState = _.clone(state);
  newState.array = action.payload.array || [];
  return newState;
}

function handleLoadFailAction(state: MyOrdersState): MyOrdersState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const myOrdersSelectors = {
  array: (state: MyOrdersState) => _.get(state, 'array', [])
};
